import axios from "axios";
import { getStorage, removeStorage, setStorage } from "../utils/storage";
import apiClient from "./apiClient";

export interface IUserInfo {
  id: number;
  username: string;
  full_name: string;
  password_updated_at: string;
  is_password_expired: boolean;
  is_activated: boolean;
  user_permissions: object;
}

const apiBase = process.env.REACT_APP_API_URL || "";

const register = (username: string, password: string) => {
  return apiClient
    .post("signup", {
      username,
      password,
    })
    .catch((e) => {
      return Promise.reject(e.response ? e.response.data : e.message);
    });
};

const login = (username: string, password: string) => {
  return apiClient
    .post("login", {
      username,
      password,
    })
    .then((response) => {
      if (response.status === 200) {
        setStorage("token", response.data.data.access_token);
        setStorage("refreshToken", response.data.data.refresh_token);
        setStorage("userInfo", JSON.stringify(response.data.data.user_info));
        setStorage("sidebarCollapse", false);
      }
      if (response.status === 401) {
        // Handle Refresh Token
        refreshToken();
      }
      return response.data;
    })
    .catch((e) => {
      return Promise.reject(e.response ? e.response.data : e.message);
    });
};

const changePassword = (current_password: string, new_password: string) => {
  const token = getStorage("token");
  return apiClient
    .put(
      "/auth/change-password",
      {
        current_password,
        new_password,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((response) => {
      if (response.status === 200) {
        console.log(response);
      }
      if (response.status === 401) {
        // Handle Refresh Token
      }
      return response;
    })
    .catch((e) => {
      return Promise.reject(e.response ? e.response.data : e.message);
    });
};

const refreshToken = async () => {
  const refresh_token = getStorage("refreshToken");

  if (!refresh_token) {
    throw new Error("No refresh token available");
  }

  try {
    const response = await axios.post(`${apiBase}api/refresh-token`, {
      refresh_token: refresh_token,
    });

    const newAccessToken = response.data.data.access_token;
    const newRefreshToken = response.data.data.refresh_token;
    const userInfo = response.data.data.user_info;

    setStorage("token", newAccessToken);
    setStorage("refreshToken", newRefreshToken);
    setStorage("userInfo", JSON.stringify(userInfo));

    return newAccessToken;
  } catch (e) {
    console.error("Error refreshing token:", e);
    removeStorage("token");
    removeStorage("refreshToken");
    removeStorage("userInfo");
    window.location.href = "/login";
    return Promise.reject(e);
  }
};

const getUserInfoAPI = async () => {
  const token = getStorage("token");
  return await apiClient
    .get("/auth/profile", {
      headers: {
        Authorization: `Bearer ${token}`, // Set the token dynamically here
      },
    })
    .then((response) => {
      if (response.status === 401) {
        console.log("Refresh Token");
        refreshToken();
      }
      return response;
    })
    .catch((e) => {
      console.log("Error", e);
      return Promise.reject(e.response ? e.response.data : e.message);
    });
};

const logout = () => {
  removeStorage("token");
  removeStorage("refreshToken");
  removeStorage("userInfo");
  return apiClient
    .post("logout")
    .then((response) => {
      return response.data;
    })
    .catch((e) => {
      return Promise.reject(e.response ? e.response.data : e.message);
    });
};

const getUserInfo = () => {
  const userInfo = getStorage("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const getToken = () => {
  const token = getStorage("token");
  return token ? token : null;
};

const AuthService = {
  register,
  login,
  logout,
  refreshToken,
  getUserInfo,
  getToken,
  changePassword,
  getUserInfoAPI,
};

export default AuthService;
